import React from 'react';
import {
  IFilterFieldsFragment,
  ILogicalOperatorFieldsFragment,
} from '../../../../../../utils/apollo/graphqlSchema';
import * as DashboardFilterViewUI from './DashboardFilterViewUI';
import DashboardBasicFilterView from './DashboardBasicFilterView';
import DashboardFilterNamedFilter from './DashboardFilterNamedFilter';

interface IProps {
  filter: IFilterFieldsFragment;
  logicOps: ILogicalOperatorFieldsFragment[];
  includeAnyValue: boolean;
}

const DashboardFilterView = ({ filter, logicOps, includeAnyValue }: IProps) => {
  const { __typename } = filter;
  return (
    <DashboardFilterViewUI.Container>
      {__typename === 'NamedFilter' ? (
        <DashboardFilterNamedFilter filter={filter} />
      ) : __typename === 'BasicFilter' ? (
        <DashboardBasicFilterView
          filter={filter}
          logicOps={logicOps}
          includeAnyValue={includeAnyValue}
        />
      ) : null}
    </DashboardFilterViewUI.Container>
  );
};

export default DashboardFilterView;
